export const extractRgb = (css: string) => {
  return css.match(/[0-9.]+/gi);
};

export const raise = (errorMessage: string): never => {
  throw new Error(errorMessage);
};

export const isWithinRange = (val: number, min: number, max: number) => min <= val && max >= val;

export const isDesktop =
  "ontouchstart" in document.documentElement ? false : true;